export enum BaccaratCardType {
    PLAYER = 'player',
    BANKER = 'banker',
    TIE = 'tie',
}
